import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as notificationApi from '../Api/notificationApi';

const NOTIFICATION_KEY = 'notifications';

export const useNotifications = (companyId) =>
	useQuery({
		queryKey: [NOTIFICATION_KEY, companyId],
		queryFn: () => notificationApi.fetchNotifications(companyId),
		enabled: !!companyId,
	});

export const useMarkNotificationAsRead = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, employeeId }) =>
			notificationApi.markNotificationAsRead(id, employeeId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [NOTIFICATION_KEY] });
		},
	});
};

export const useDeleteNotification = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, employeeId }) =>
			notificationApi.deleteNotification(id, employeeId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [NOTIFICATION_KEY] });
		},
	});
};
